export enum RegistrationModelSerialPageStatus {
  Complete = 'Complete',
  CodeExpired = 'CodeExpired',
  Pending = 'Pending',
}
